/**
 * Send Ipsos event.
 * @param section
 */
export function sendIpsosEvent(section) {
  if (
    ('undefined' !== typeof section) &&
    typeof window !== 'undefined' &&
    ('dm' in window) &&
    window.dm &&
    typeof window.dm.AjaxEvent === 'function'
  ) {
    window.dm.AjaxEvent('pageview', null, section);
  }
}
